import React, { useEffect, useState } from 'react'
import './ContentShadow.scss'

// 预加载图片函数
const preloadImage = (imageUrl) => {
  return require(`./images/${imageUrl}`) // 假设图片在 'images' 文件夹下
}

const ContentShadow = ({
  children,
  active = true,
  imageUrl,
  top = null,
  right = null,
  bottom = null,
  left = null,
  width = 0,
  height = 0,
  onPrevClick,
  onNextClick,
  show,
  p_top = null,
  p_right = null,
  p_bottom = null,
  p_left = null,
  r_top = null,
  r_right = null,
  r_bottom = null,
  r_left = null,
  text = null
}) => {
  // 加载状态
  const [loaded, setLoaded] = useState(false)
  let imageSrc = ''

  try {
    // 使用 require 预加载图片
    imageSrc = preloadImage(imageUrl)
  } catch (error) {
    console.error('图片加载失败:', error)
    // 可以设置一个默认图片或者处理错误
    imageSrc = '' // 或者设置一个默认图片路径
  }

  // 用于控制缓冲动画
  const [fadeIn, setFadeIn] = useState(false)

  useEffect(() => {
    if (show && imageUrl) {
      setFadeIn(false)
      setTimeout(() => {
        setFadeIn(true)
      }, 100)
    }
  }, [show, imageUrl])

  if (!show) {
    return children
  }

  return (
    <div className="shadow-container">
      {/* 背景阴影覆盖层 */}
      {active && <div className="shadow-overlay" />}

      {/* 被包裹的内容 */}
      <div className="content-wrapper">
        {children}
        <div className="content-mask" />
      </div>

      {/* 图片显示区域 */}
      {imageUrl && (
        <div
          alt="content-image"
          className={`content-image ${fadeIn ? 'fade-in' : ''}`}
          style={{
            backgroundImage: `url(${imageSrc})`,
            width: `${width}px`,
            height: `${height}px`,
            top: `${top}px`,
            right: `${right}px`,
            bottom: `${bottom}px`,
            left: `${left}px`,
            opacity: fadeIn ? 1 : 0
          }}
        >
          {/* 退出按钮 */}
          <button
            className="prev-button"
            style={{
              top: `${p_top}px`,
              right: `${p_right}px`,
              bottom: `${p_bottom}px`,
              left: `${p_left}px`
            }}
            onClick={onPrevClick}
          >
            退出
          </button>
          {/* 下一步按钮 */}
          <button
            className="next-button"
            style={{
              top: `${r_top}px`,
              right: `${r_right}px`,
              bottom: `${r_bottom}px`,
              left: `${r_left}px`
            }}
            onClick={onNextClick}
          >
            {text}
          </button>
        </div>
      )}
    </div>
  )
}

export default ContentShadow
